module.exports = __webpack_public_path__ + "static/media/facility-settings.3e5a6180.svg";